import React from 'react'
import { NavLink } from 'react-router-dom'
import { Grid, Button } from '@material-ui/core'
import SelectFieldGroup from '../../../common/SelectFieldGroup'
import PropTypes from 'prop-types'

const SecurityGroupForm = props => {
  const {
    onResourceFormSubmit,
    onResourceSelect,
    groupOptions,
    classes,
    page,
    toDelete,
    group,
    resourceDeleteConfirmed,
    resourceDeleteCancelled,
    showResourceDeleteConfirmWindow,
    resourceDeleteConfirmWindow,
  } = props
  return (
    <div className={'u-p-medium'}>
      <form onSubmit={onResourceFormSubmit}>
        {groupOptions && (
          <Grid container spacing={2}>
            <Grid item sm={9} className={'u-p-small'}>
              <SelectFieldGroup
                options={groupOptions}
                label={'Add page to group'}
                type={'text'}
                onChange={onResourceSelect}
                value={group}
                name={'group'}
              />
            </Grid>
            <Grid item sm={3} className={'u-p-small'}>
              <div className="c-field c-pt-cust-23  u-m-zero">
                <Button className={`${classes.buttonPrimary} u-p-xsmall c-btn--fullwidth`}>ADD page to group</Button>
              </div>
            </Grid>
          </Grid>
        )}
      </form>
      <ul className="u-m-zero list-group">
        {page &&
          page.groups &&
          page.groups.map(group => (
            <li
              key={group._id}
              className="u-border-bottom u-border-top u-p-xsmall list-group-item d-flex justify-content-between align-items-center"
            >
              {group.name}
              {!showResourceDeleteConfirmWindow || toDelete.id !== group._id ? (
                <span className="badge-pill">
                  <Button
                    className={`c-btn ${classes.buttonSecondary} c-btn--small u-mr-small`}
                    onClick={e => {
                      resourceDeleteConfirmWindow('pages', group._id)
                    }}
                  >
                    Delete
                  </Button>
                  <NavLink
                    exact={true}
                    to={`/settings/groups/view/${group._id}`}
                    className={`c-btn ${classes.buttonInfo} c-btn--small u-ml-small`}
                  >
                    Edit Group
                  </NavLink>
                  <NavLink
                    exact={true}
                    to={`/settings/groups/view/${group._id}`}
                    className={`c-btn ${classes.buttonPrimary} c-btn--small u-ml-small`}
                  >
                    View Group
                  </NavLink>
                </span>
              ) : (
                <span className="badge-pill">
                  <Button
                    type={'button'}
                    className={`c-btn ${classes.buttonSecondary} u-m-xsmall c-btn--small has-arrow u-text-center`}
                    onClick={e => {
                      resourceDeleteConfirmed()
                    }}
                  >
                    Delete Page From Group
                  </Button>
                  <button
                    type={'button'}
                    className={`c-btn ${classes.buttonSecondary} u-m-xsmall c-btn--small has-arrow u-text-center`}
                    onClick={e => {
                      resourceDeleteCancelled()
                    }}
                  >
                    Cancel
                  </button>
                </span>
              )}
            </li>
          ))}
      </ul>
    </div>
  )
}

SecurityGroupForm.propTypes = {
  onResourceFormSubmit: PropTypes.func.isRequired,
  onResourceSelect: PropTypes.func.isRequired,
  groupOptions: PropTypes.array,
  classes: PropTypes.object.isRequired,
  page: PropTypes.object,
  toDelete: PropTypes.object,
  group: PropTypes.string,
  resourceDeleteConfirmed: PropTypes.func.isRequired,
  resourceDeleteCancelled: PropTypes.func.isRequired,
  showResourceDeleteConfirmWindow: PropTypes.bool,
  resourceDeleteConfirmWindow: PropTypes.func,
}

export default SecurityGroupForm
